// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2TAyu","colMaxWidth":"Table_colMaxWidth__2fHbn"};